import Service, { service } from '@ember/service';

export default class DecisionDefRepoService extends Service {
  @service store;

  createDecisionDefForTask(task, defParams = {}) {
    defParams.task = task;
    const def = this.store.createRecord('decision-def', defParams);
    task.taskConfigs.forEach(taskConfig => {
      this.store.createRecord('decision-def-config', {
        decisionDef: def,
        taskConfig,
      });
    });
    return def;
  }
}
